export function requestIsActive(status: string | undefined): boolean {
  return status === "pending" || status === "submitted" || status === "running";
}
